import { KeyVerticalOutlineIcon } from '@tableau/icons/KeyVerticalOutlineIcon';
import { assertUnreachable } from '@tableau/vizportalclient-common-components';
import { ButtonType, TabStyles } from '@tableau/widgets';
import React from 'react';
import { Formatters, Messages } from '../../../../../../gen-src/Localize';
import { LabelPopover } from '../LabelPopover';
import { SensitiveLabelColor } from '../Styles';
import { LabelRenderControlsWrapper } from '../shared/LabelRenderProps';
import { LabelType, localizeLabelTypeName, stringtoLabelType } from '../shared/LabelType';
import { ButtonTriggerElementProps, ChipTriggerElementProps, useControlledPopover } from '../shared/useControlledPopover';
import { SensitivityRenderProps } from './SensitivityProps';

export type SensitivityLabelProps = SensitivityRenderProps & LabelRenderControlsWrapper;

export function SensitivityLabel(props: SensitivityLabelProps): JSX.Element {
  const popover = useControlledPopover<SensitivityRenderProps>({
    testId: props.testId,
    popoverProps: {
      title: sensitivityLabelTitle(props),
      placement: props.controls?.popoverPlacement ?? 'bottom-start',
    },
    content: LabelPopover,
    controlKind: props.controls?.kind ?? 'icon',
    iconProps: sensitivityLabelIconProps,
    chipProps: sensitivityLabelChipProps,
    onClick: props.onClick,
    loading: props.loading,
    props: {
      ...props
    }
  })
  return popover ?? <></>;
}

function sensitivityLabelTitleCalculation(count: number, labelType: string): string {
  if (count <= 0) {
    return '';
  }

  if (count === 1) {
    return labelType in LabelType ? localizeLabelTypeName(stringtoLabelType(labelType)) : labelType
  }

  return Messages.Label_sensitivity_chip_message({
    MESSAGE_COUNT: count,
    MESSAGE_COUNT_LOC: Formatters.formatCount(count),
  });
}

function sensitivityLabelTitle(props: SensitivityLabelProps): string {
  switch (props.kind) {
    case 'dehydrated': {
      return sensitivityLabelTitleCalculation(props.count, props.labelValue);
    }
    case 'hydrated': {
      const count = (props.anchored?.labels.length ?? 0) + (props.upstream?.labels.length ?? 0) + (props.parented?.labels.length ?? 0);
      const labelType = props.anchored?.labels[0]?.type ?? props.parented?.labels[0]?.type ?? props.upstream?.labels[0]?.type ?? '';

      return sensitivityLabelTitleCalculation(count, labelType);
    }
    default:
      assertUnreachable(props)
      return '';
  }
}

function sensitivityLabelIconProps(): ButtonTriggerElementProps {
  return {
    getContent: (_) => <KeyVerticalOutlineIcon size={14} style={{ color: SensitiveLabelColor }} alt={Messages.DataQualityTypeSensitiveData()} />,
    style: {
      padding: TabStyles.Spacing.SmallSpace,
      cursor: 'pointer',
    },
    buttonType: ButtonType.Icon,
    kind: 'button-props',
  }
}

function sensitivityLabelChipProps(): ChipTriggerElementProps {
  return {
    stickerType: 'violet',
    icon: <KeyVerticalOutlineIcon size={14} style={{ color: SensitiveLabelColor }} alt={Messages.DataQualityTypeSensitiveData()} />,
    kind: 'sticker-props'
  }
}
